var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"page-breadcrumb d-flex justify-content-between"},[_c('h2',{staticClass:"page-title"},[_vm._v("Reputation")])])])
}]

export { render, staticRenderFns }